const INVOICE_TYPE = {
    INVOICE: 0,
    CREDIT_NOTE: 1,
    INVOICE_AND_RECEIPT: 10,
}

const INVOICE_TYPES = [
    { id: INVOICE_TYPE.INVOICE, label: 'Invoice' },
    { id: INVOICE_TYPE.CREDIT_NOTE, label: 'Credit note' },
    { id: INVOICE_TYPE.INVOICE_AND_RECEIPT, label: 'Invoice/Receipt' },
]

export { INVOICE_TYPE, INVOICE_TYPES }
export default INVOICE_TYPE



// WEBPACK FOOTER //
// ./src/enums/invoiceType.js